// Is loaded by gulp and added to the layout.min.js

$.notify.addStyle('template', {
    html: `
        <div>
            <h4 data-notify-text="title"></h4>
            <span data-notify-text="text"></span>
        </div>
`
});

const startTenantHub = async tenantId =>
{
    const tenantHubConnection = new signalR.HubConnectionBuilder()
        .withUrl("/tenantHub?tenantId=" + encodeURIComponent(tenantId))
        .configureLogging(signalR.LogLevel.Warning)
        .build();
    
    tenantHubConnection.on("OnUsersUpdated", function () {
        const users = $('#users');
        if (!users || !users.length) {
            return;
        }

        console.log('upading');
        users.DataTable().ajax.reload();
    });

    tenantHubConnection.on("ReceiveNotification", function (tenantId, title, message, type) {
        $.notify({
            title: title,
            text: message
        }, {
            position: 'top center',
            className: type,
            duration: 5000,
            style: 'template'
        });
    });
    
    const start = async () => {
        try {
            await tenantHubConnection.start();
        } catch (err) {
            console.log(err);
            setTimeout(start, 5000);
        }
    };
    
    tenantHubConnection.onclose(start);
    
    start();
};

if (typeof pageInfo !== "undefined" && pageInfo.tenantId)
{
    startTenantHub(pageInfo.tenantId);
}